module.exports = require("@noble/secp256k1");